import { getLoadMstv } from './mstv-player-loader';

export function stickyVideo(dataEdtn, isAutoPlay) {
  let videoBoxWrapper = document.getElementsByClassName('videowrapper')[0]; //mstv-video-wrapper
  let videoWrapper = videoBoxWrapper.getElementsByClassName('video-player')[0]; //video-player
  const isMstv = videoWrapper.dataset.videoName == 'mstv' ? true : false;
  const isYoutube = videoWrapper.dataset.videoName == 'youtube' ? true : false;

  if (videoWrapper != null) {
    getLoadMstv().then((api) => {
      api.loadMstv(videoWrapper, dataEdtn, isMstv, isAutoPlay, isYoutube);
    });
  }
}
